(function() {
  var activeItem = null;
  var hoverTimeout = null;
  var leaveTimeout = null;
  var isTouch = false;

  function init() {
    var navBar = document.querySelector('.cmm-nav-bar');
    if (!navBar) return;

    document.addEventListener('touchstart', function() {
      isTouch = true;
    }, { once: true, passive: true });

    initScrollFades(navBar);
    bindNavEvents(navBar);
  }

  function initScrollFades(navBar) {
    var wrapper = navBar.querySelector('.cmm-scroll-wrapper');
    if (!wrapper) return;
    if (wrapper.querySelector('.cmm-scroll-fade-left')) return;

    var clones = wrapper.querySelectorAll('.cmm-clone');
    clones.forEach(function(c) { c.remove(); });

    var fadeLeft = document.createElement('div');
    fadeLeft.className = 'cmm-scroll-fade-left';
    var fadeRight = document.createElement('div');
    fadeRight.className = 'cmm-scroll-fade-right';

    wrapper.appendChild(fadeLeft);
    wrapper.appendChild(fadeRight);

    function updateFades() {
      var sl = wrapper.scrollLeft;
      var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

      if (maxScroll <= 2) {
        fadeLeft.classList.remove('is-visible');
        fadeRight.classList.remove('is-visible');
        return;
      }

      fadeLeft.classList.toggle('is-visible', sl > 4);
      fadeRight.classList.toggle('is-visible', sl < maxScroll - 4);
    }

    wrapper.addEventListener('scroll', updateFades, { passive: true });
    window.addEventListener('resize', updateFades);
    setTimeout(updateFades, 100);
  }

  function bindNavEvents(navBar) {
    navBar.addEventListener('mouseenter', handleItemEnter, true);
    navBar.addEventListener('mouseleave', handleItemLeave, true);
    navBar.addEventListener('click', handleItemClick, true);

    var tabBtns = navBar.querySelectorAll('.cmm-tab-btn');
    tabBtns.forEach(function(btn) {
      btn.addEventListener('mouseenter', function() {
        activateTab(this);
      });
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        activateTab(this);
      });
    });

    document.addEventListener('click', function(e) {
      if (!navBar.contains(e.target)) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAll();
      }
    });
  }

  function handleItemEnter(e) {
    var item = e.target.closest('.cmm-nav-item');
    if (!item || isTouch) return;

    clearTimeout(leaveTimeout);
    clearTimeout(hoverTimeout);
    var self = item;
    hoverTimeout = setTimeout(function() {
      openItem(self);
    }, 120);
  }

  function handleItemLeave(e) {
    var item = e.target.closest('.cmm-nav-item');
    if (!item || isTouch) return;

    var related = e.relatedTarget;
    if (related && item.contains(related)) return;

    clearTimeout(hoverTimeout);
    leaveTimeout = setTimeout(function() {
      closeAll();
    }, 200);
  }

  function handleItemClick(e) {
    var link = e.target.closest('.cmm-nav-link');
    if (!link) return;
    var item = link.closest('.cmm-nav-item');
    if (!item) return;

    var panel = item.querySelector('.cmm-mega-panel, .cmm-simple-dropdown');
    if (!panel) return;

    if (item.classList.contains('is-active')) {
      var href = link.getAttribute('href');
      if (href && href !== '#' && href !== '') return;
      closeAll();
      e.preventDefault();
    } else {
      e.preventDefault();
      openItem(item);
    }
  }

  function openItem(item) {
    if (activeItem && activeItem !== item) {
      activeItem.classList.remove('is-active');
    }
    item.classList.add('is-active');
    activeItem = item;

    var navBarEl = item.closest('.cmm-nav-bar');
    var navRect = navBarEl ? navBarEl.getBoundingClientRect() : null;

    var megaPanel = item.querySelector('.cmm-mega-panel');
    if (megaPanel && navRect) {
      megaPanel.style.top = navRect.bottom + 'px';
    }

    var dropdown = item.querySelector('.cmm-simple-dropdown');
    if (dropdown && navRect) {
      var linkEl = item.querySelector('.cmm-nav-link');
      if (linkEl) {
        var linkRect = linkEl.getBoundingClientRect();
        dropdown.style.top = navRect.bottom + 'px';
        dropdown.style.left = (linkRect.left + linkRect.width / 2 - 110) + 'px';
      }
    }

    var firstTab = item.querySelector('.cmm-tab-btn');
    if (firstTab && !item.querySelector('.cmm-tab-btn.is-active')) {
      activateTab(firstTab);
    }
  }

  function closeAll() {
    if (activeItem) {
      activeItem.classList.remove('is-active');
      activeItem = null;
    }
  }

  function activateTab(btn) {
    var container = btn.closest('.cmm-mega-inner');
    if (!container) return;

    container.querySelectorAll('.cmm-tab-btn').forEach(function(b) {
      b.classList.remove('is-active');
    });
    container.querySelectorAll('.cmm-tab-panel').forEach(function(p) {
      p.classList.remove('is-active');
    });

    btn.classList.add('is-active');
    var targetId = btn.getAttribute('data-tab-target');
    if (targetId) {
      var panel = container.querySelector('#' + targetId);
      if (panel) {
        panel.classList.add('is-active');
      }
    }
  }

  function initMobile() {
    var mobileMenu = document.getElementById('mobile-menu');
    if (!mobileMenu) return;

    mobileMenu.addEventListener('click', function(e) {
      var tabBtn = e.target.closest('.cmm-mobile-tab-btn');
      if (!tabBtn) return;

      e.preventDefault();
      var content = tabBtn.nextElementSibling;
      if (!content) return;

      var isOpen = content.classList.contains('is-open');
      tabBtn.classList.toggle('is-expanded', !isOpen);
      content.classList.toggle('is-open', !isOpen);
      content.style.display = isOpen ? 'none' : 'block';
    });

    initMobileMenuFallback(mobileMenu);
    initMobilePanelFallback(mobileMenu);
    initHideAuthOnMenuOpen(mobileMenu);
  }

  function initHideAuthOnMenuOpen(mobileMenu) {
    var authBar = document.querySelector('.mobile-auth-bar');
    if (!authBar) return;

    function sync() {
      var hidden = mobileMenu.getAttribute('aria-hidden');
      authBar.style.display = (hidden === 'false') ? 'none' : '';
    }

    var observer = new MutationObserver(sync);
    observer.observe(mobileMenu, { attributes: true, attributeFilter: ['aria-hidden'] });
    sync();
  }

  function initMobileMenuFallback(mobileMenu) {
    var toggleBtn = document.querySelector('[data-action="toggle-menu"][aria-controls="mobile-menu"]');
    if (!toggleBtn) return;

    toggleBtn.addEventListener('click', function(e) {
      var stateBefore = toggleBtn.getAttribute('aria-expanded');

      setTimeout(function() {
        var stateAfter = toggleBtn.getAttribute('aria-expanded');

        if (stateAfter !== stateBefore) return;

        var isExpanded = stateAfter === 'true';

        if (isExpanded) {
          toggleBtn.setAttribute('aria-expanded', 'false');
          mobileMenu.setAttribute('aria-hidden', 'true');
          mobileMenu.style.maxHeight = '';

          mobileMenu.querySelectorAll('.mobile-menu__panel.is-open').forEach(function(panel) {
            panel.classList.remove('is-open');
          });
        } else {
          toggleBtn.setAttribute('aria-expanded', 'true');
          mobileMenu.setAttribute('aria-hidden', 'false');

          var headerEl = document.querySelector('.header');
          if (headerEl) {
            mobileMenu.style.maxHeight = (window.innerHeight - headerEl.getBoundingClientRect().bottom) + 'px';
          }
        }
      }, 0);
    });
  }

  function initMobilePanelFallback(mobileMenu) {
    var mobileNavContainer = mobileMenu.closest('.header__mobile-nav') || mobileMenu.parentElement;
    if (!mobileNavContainer) return;

    mobileNavContainer.addEventListener('click', function(e) {
      var openBtn = e.target.closest('[data-action="open-panel"]');
      if (openBtn) {
        var panelId = openBtn.getAttribute('aria-controls');
        if (!panelId) return;
        var panel = document.getElementById(panelId);
        if (!panel) return;

        setTimeout(function() {
          if (!panel.classList.contains('is-open')) {
            openBtn.setAttribute('aria-expanded', 'true');
            panel.classList.add('is-open');
          }
        }, 0);
        return;
      }

      var closeBtn = e.target.closest('[data-action="close-panel"]');
      if (closeBtn) {
        var openPanel = closeBtn.closest('.mobile-menu__panel.is-open');
        if (!openPanel) return;

        setTimeout(function() {
          if (openPanel.classList.contains('is-open')) {
            openPanel.classList.remove('is-open');
            var trigger = mobileNavContainer.querySelector('[aria-controls="' + openPanel.id + '"]');
            if (trigger) {
              trigger.setAttribute('aria-expanded', 'false');
            }
          }
        }, 0);
      }
    });
  }

  function interleaveLongColumns() {
    var lists = document.querySelectorAll('.cmm-column--long .cmm-link-list');
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      if (ul.getAttribute('data-interleaved')) continue;
      ul.setAttribute('data-interleaved', '1');

      var items = Array.prototype.slice.call(ul.children);
      if (items.length <= 8) continue;

      var col1 = document.createElement('ul');
      col1.className = 'cmm-link-list';
      var col2 = document.createElement('ul');
      col2.className = 'cmm-link-list';

      for (var j = 0; j < items.length; j++) {
        if (j % 2 === 0) {
          col1.appendChild(items[j]);
        } else {
          col2.appendChild(items[j]);
        }
      }

      var wrapper = document.createElement('div');
      wrapper.className = 'cmm-link-list-wrap';
      wrapper.appendChild(col1);
      wrapper.appendChild(col2);

      ul.parentNode.replaceChild(wrapper, ul);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      initMobile();
      interleaveLongColumns();
    });
  } else {
    init();
    initMobile();
    interleaveLongColumns();
  }
})();
